import React from 'react';
import { IconSVG } from '../../../components';
import { getAccentColor } from '../../../utils';

const accentColor = getAccentColor();

const Call: React.FC = () => (
  <IconSVG width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.25 0.905273V2.90527H14.836L8.54297 9.19827L9.95797 10.6123L16.25 4.31927V8.90527H18.25V0.905273H10.25Z"
      fill={accentColor}
    />
    <path
      d="M16.25 12.9053H12.25C11.697 12.9053 11.25 13.3523 11.25 13.9053V14.9053C7.25 14.9053 4.313 11.8433 4.25 7.90527H5.25C5.803 7.90527 6.25 7.45827 6.25 6.90527V2.90527C6.25 2.35227 5.803 1.90527 5.25 1.90527H1.25C0.698 1.90527 0.25 2.35227 0.25 2.90527V7.90527C0.25 13.9803 5.175 18.9053 11.25 18.9053H16.25C16.803 18.9053 17.25 18.4583 17.25 17.9053V13.9053C17.25 13.3523 16.803 12.9053 16.25 12.9053Z"
      fill="black"
    />
  </IconSVG>
);

export default Call;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/icons/Call.tsx